import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/order/";

//单笔获取
export function get_order(config?) {
  return XtAxios4.get(URL + `order`, config);
}

//单笔下单
export function post_order(config?) {
  return XtAxios4.post(URL + `order`, null, config);
}

//单笔撤单
export function delete_order(config?) {
  return XtAxios4.delete(URL + `order`, config);
}

//当前挂单查询
export function get_openOrder(config?) {
  return XtAxios4.get(URL + `open-order`, config);
}

//撤销当前挂单
export function delete_openOrder(config?) {
  return XtAxios4.delete(URL + `open-order`, config);
}

//历史订单查询
export function get_historyOrder(config?) {
  return XtAxios4.get(URL + `history-order`, config);
}

//历史成交查询
export function get_trade(config) {
  return XtAxios4.get(URL + `trade`, config);
}
